import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import DialogList from 'src/dialogs';

interface IEnterCheckNumberDialogProps {
    dialogName: string;
    handleReport?: (category: string, subcategory: string) => void;
    setCheckNumber?: (checkNumber: number) => void;
    setCheckDate?: (checkNumber: string) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
}

const EnterCheckNumberDialog = (props: IEnterCheckNumberDialogProps) => {
    const { register, errors, getValues } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('ReportOptionsDialog onCreate()');
    };

    // const OKClicked = () => {
    //     console.log('OK Clicked');
    //     let data = getValues();

    //     props.handleReport(getValues('category'), getValues('subcategory'));
    //     props.hideDialog();

    //     console.log(data);
    // };

    const OKClicked = () => {
        let data = getValues();
        props.setCheckNumber(data.check.checkNumber);
        props.setCheckDate(data.check.checkDate);
        console.log('OK Clicked', data);
        props.hideDialog();
        props.showDialog(DialogList.CREATE_CHECK_WARNING);
    };

    return (
        <Dialog title="Enter Check Number" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <RHFInputBox
                        label="Check Number"
                        labelOnLeft={true}
                        labelStyle={{ width: '15rem'}}
                        name={`check.checkNumber`}
                        type="number"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                    />
                    <RHFInputBox
                        label="Check Date"
                        labelOnLeft={true}
                        defaultVal={new Date().toLocaleDateString()}
                        labelStyle={{ width: '15rem'}}
                        name={`check.checkDate`}
                        type="date"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                    />
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default EnterCheckNumberDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/EnterCheckNumberDialog.tsx